"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectProvider = exports.toHex = void 0;
const provider_1 = require("./provider");
const sdk_1 = require("../sdk");
function toHex(n) {
    return `0x${n.toString(16)}`;
}
exports.toHex = toHex;
/**
 * Returns a Promise that resolves to the value of window.ethereum if it is
 * set within the given timeout, or null.
 * The Promise will not reject, but an error will be thrown if invalid options
 * are provided.
 *
 * @param options - Options bag.
 * @param options.silent - Whether to silence console errors. Does not affect
 * thrown errors. Default: false
 * @param options.timeout - Milliseconds to wait for 'ethereum#initialized' to
 * be dispatched. Default: 3000
 * @returns A Promise that resolves with the Provider if it is detected within
 * given timeout, otherwise null.
 */
function detectProvider(parentFrameUrl, { silent = false, timeout = 3000, } = {}) {
    validateInputs();
    let handled = false;
    let unbind;
    let chainInfo;
    return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
        if (window.ManifoldBridgeAppWeb3Provider)
            return resolve(window.ManifoldBridgeAppWeb3Provider);
        if (!window.ManfioldBridgeAppSDK)
            window.ManifoldBridgeAppSDK = new sdk_1.BridgeAppSDK(parentFrameUrl);
        try {
            chainInfo = yield window.ManifoldBridgeAppSDK.fetchChainInfo();
        }
        catch (e) {
            if (e.code === 4900) {
                // Do nothing, not yet connected
            }
            else {
                throw e;
            }
        }
        if (chainInfo) {
            handleEthereum();
        }
        else {
            unbind = window.ManifoldBridgeAppSDK.on('chainChanged', handleEthereum);
            setTimeout(() => {
                handleEthereum();
            }, timeout);
        }
        function handleEthereum() {
            return __awaiter(this, void 0, void 0, function* () {
                if (handled) {
                    return;
                }
                handled = true;
                try {
                    if (!chainInfo)
                        chainInfo = yield window.ManifoldBridgeAppSDK.fetchChainInfo();
                }
                catch (e) {
                    // Do nothing, no provider available yet
                }
                if (unbind) {
                    unbind();
                    unbind = undefined;
                }
                if (window.ManifoldBridgeAppWeb3Provider)
                    return resolve(window.ManifoldBridgeAppWeb3Provider);
                if (chainInfo) {
                    window.ManifoldBridgeAppWeb3Provider = new provider_1.BridgeAppWeb3Provider(chainInfo, window.ManifoldBridgeAppSDK);
                    return resolve(window.ManifoldBridgeAppWeb3Provider);
                }
                else {
                    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                    !silent && console.error('detectProvider:', 'Unable to detect parent window.ethereum.');
                    return resolve(null);
                }
            });
        }
    }));
    function validateInputs() {
        if (typeof silent !== 'boolean') {
            throw new Error('@metamask/detect-provider: Expected option \'silent\' to be a boolean.');
        }
        if (typeof timeout !== 'number') {
            throw new Error('@metamask/detect-provider: Expected option \'timeout\' to be a number.');
        }
    }
}
exports.detectProvider = detectProvider;
//# sourceMappingURL=provider-utils.js.map